import SettingsBox from 'src/Elements/Data/SettingsBox'
import React, { useCallback } from 'react'
import { Stack } from '@mui/material'
import { useField, useFormikContext } from 'formik'
import { OptionalTooltipWrapper } from '@e3dc-react/shell/Elements/Tooltip'
import Toggle from 'src/Components/toggle/Toggle'

interface Props {
  label: string
  name: string
  disabled?: boolean
  tooltipText?: string
}

const PhaseFieldSet: React.VFC<Props> = ({ label, name, disabled = false, tooltipText = '' }) => {
  const [field] = useField(name)
  const { setFieldValue } = useFormikContext()

  const updateForIndex = useCallback(
    (index: number, checked: boolean, source: boolean[]): void => {
      const mutated = [...source]
      mutated[index] = checked
      setFieldValue(name, mutated)
    },
    [setFieldValue, name]
  )

  /* TODO: find smarter solution */
  const handleChange1 = useCallback(
    (event: { target: { checked: boolean } }) => {
      updateForIndex(0, event.target.checked, field.value)
    },
    // eslint-disable-next-line
    [updateForIndex, field.value]
  )
  const handleChange2 = useCallback(
    (event: { target: { checked: boolean } }) => {
      updateForIndex(1, event.target.checked, field.value)
      // eslint-disable-next-line
    },
    [updateForIndex, field.value]
  )
  const handleChange3 = useCallback(
    (event: { target: { checked: boolean } }) => {
      updateForIndex(2, event.target.checked, field.value)
      // eslint-disable-next-line
    },
    [updateForIndex, field.value]
  )

  const fields = (
    <Stack direction="row">
      <OptionalTooltipWrapper titleKey={tooltipText}>
        <Toggle label="L1" name={`${name}1`} checked={field.value[0]} onChange={handleChange1} disabled={disabled} />
        <Toggle label="L2" name={`${name}2`} checked={field.value[1]} onChange={handleChange2} disabled={disabled} />
        <Toggle label="L3" name={`${name}3`} checked={field.value[2]} onChange={handleChange3} disabled={disabled} />
      </OptionalTooltipWrapper>
    </Stack>
  )
  return <SettingsBox title={label} suffix={fields} disabled={disabled} />
}

export default PhaseFieldSet
